import Select from "react-select";

function SelectDropdown({
  options = [],
  value,
  onChange,
  placeholder,
  isClearable = false,
  name,
  styles = {},
  className = "",
  controlMarginRight = "20px",
  controlHeight = "40px",
  controlBorderRadius = "4px",
}) {
  const selectedOption =
    options.find((option) => option.value?.toString() === value?.toString()) ||
    null;

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      cursor: "pointer",
      height: controlHeight,
      minHeight: controlHeight,
      marginRight: controlMarginRight,
      borderRadius: controlBorderRadius,
      border: state.isFocused ? "1px solid #0060bc" : "1px solid #ccc",
      boxShadow: "none",
      "&:hover": {
        borderColor: "#0060bc",
      },
    }),
    option: (provided, state) => ({
      ...provided,
      cursor: "pointer",
      backgroundColor: state.isFocused
        ? "#0060bc"
        : state.isSelected
        ? "#ccc"
        : "white",
      color: state.isFocused ? "white" : state.isSelected ? "#000" : "#000",
    }),
    menuPortal: (provided) => ({
      ...provided,
      zIndex: 9999,
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
    }),
  };

  const mergedStyles = {
    ...customStyles,
    ...styles,
  };

  return (
    <Select
      name={name}
      options={options}
      value={selectedOption}
      onChange={onChange}
      placeholder={placeholder}
      styles={mergedStyles}
      menuPortalTarget={document.body}
      menuPosition="fixed"
      isClearable={isClearable}
      className={className}
      classNamePrefix="passeazy-react-select"
    />
  );
}

export default SelectDropdown;
